var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "modal fade show",
        attrs: {
          id: "deleteBrModal",
          "aria-hidden": "true",
          "aria-labelledby": "exampleModalLabel",
          "data-backdrop": "static",
          role: "dialog",
          tabindex: "-1",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog",
            attrs: {
              role: "document",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-content",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-header",
                  },
                  [
                    _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: {
                          id: "exampleModalLabel",
                        },
                      },
                      [_vm._v(" Delete budget request(s) ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: {
                          "aria-label": "Close",
                          "data-dismiss": "modal",
                          type: "button",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            attrs: {
                              "aria-hidden": "true",
                            },
                          },
                          [_vm._v("×")]
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "modal-body",
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "The selected budget request(s) can not be deleted."
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        'Only budget requests that were in a "Draft" or "Submitted" state on removal can be deleted.'
                      ),
                    ]),
                    _c("br"),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "modal-footer",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: {
                          "data-dismiss": "modal",
                          type: "button",
                        },
                      },
                      [_vm._v(" BACK TO BUDGET REQUESTS ")]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }